module.exports = __webpack_public_path__ + "img/wc.945e9248.png";